var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"resizableDiv",style:(_vm.containerStyle)},[_c('div',{staticClass:"resize-handle",attrs:{"draggable":""},on:{"dragstart":_vm.onDragstart,"dragend":_vm.onDragend}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }